import React from "react";
import { createTheme } from "@mui/material/styles";
import { ExpandMore } from "@mui/icons-material";

export const appTheme = createTheme({
  typography: {
    fontFamily: "var(--font-family-manrope, 'Manrope')",
  },
  components: {
    MuiMenuItem: {
      styleOverrides: {
        root: {
          fontFamily: "var(--font-family-manrope, 'Manrope') !important",
          fontSize: "14px !important",
        },
      },
    },
    MuiSelect: {
      defaultProps: {
        IconComponent: (props: any) => (
          <ExpandMore
            {...props}
            sx={{
              fontSize: "18px !important",
              color: "inherit",
              ...props.sx,
            }}
          />
        ),
      },
      styleOverrides: {
        icon: {
          color: "inherit",
          top: "calc(50% - 9px)",
          right: "7px",
          transition: "transform 0.2s ease",
          "&.MuiSelect-iconOpen": {
            transform: "rotate(180deg)",
          },
        },
      },
    },
    MuiAutocomplete: {
      defaultProps: {
        popupIcon: <ExpandMore sx={{ fontSize: 18, color: "inherit" }} />,
      },
    },
    MuiMenu: {
      styleOverrides: {
        list: {
          paddingTop: "4px !important",
          paddingBottom: "4px !important",
          padding: "4px 0 !important",
        },
      },
    },
    MuiList: {
      styleOverrides: {
        padding: {
          paddingTop: "4px !important",
          paddingBottom: "4px !important",
        },
      },
    },
    MuiSwitch: {
      styleOverrides: {
        root: {
          width: 42,
          height: 24,
          padding: 0,
          display: "inline-flex",
          "&.Mui-disabled": {
            cursor: "not-allowed",
          },
        },
        switchBase: {
          padding: 2,
          margin: 0,
          transitionDuration: "300ms",
          "&.Mui-checked": {
            transform: "translateX(18px)",
            color: "#ffffff",
            "& + .MuiSwitch-track": {
              backgroundColor:
                "var(--action-button-background-color, #2563eb) !important",
              opacity: "1 !important",
              border: 0,
            },
          },
          "&.Mui-disabled": {
            color: "#ffffff",
            cursor: "not-allowed",
            "& + .MuiSwitch-track": {
              opacity: "0.45 !important",
              cursor: "not-allowed",
            },
          },
          "&.Mui-checked.Mui-disabled": {
            color: "#ffffff",
            opacity: 0.9,
            "& + .MuiSwitch-track": {
              backgroundColor:
                "var(--action-button-background-color, #2563eb) !important",
              opacity: "0.45 !important",
              cursor: "not-allowed",
            },
          },
        },
        thumb: {
          boxSizing: "border-box",
          width: 20,
          height: 20,
          backgroundColor: "#ffffff",
          boxShadow: "0 1px 3px rgba(0, 0, 0, 0.2)",
        },
        track: {
          borderRadius: 12,
          backgroundColor: "#cbd5e1 !important",
          opacity: "1 !important",
          transition: "background-color 300ms",
        },
      },
    },
    MuiFormControlLabel: {
      styleOverrides: {
        root: {
          marginLeft: 0,
          marginRight: 0,
          gap: "8px",
          alignItems: "center",
          "&.MuiFormControlLabel-labelPlacementStart": {
            marginLeft: 0,
            marginRight: 0,
            gap: "12px",
          },
        },
        label: {
          fontFamily: "var(--font-family-manrope, 'Manrope')",
          fontSize: "14px",
        },
      },
    },
  },
});
